/* KULT Produktseiten-Baukasten (E82) – assets/kult-produkt.js
 * Sprungleiste (aktiv + Abstand unter Kopfzeile), YouTube als Zwei-Klick-Fassade mit Zeitmarken, Video-Filter,
 * Vorher/Nachher-Regler, Bildansicht, „Passt dazu“ in den Warenkorb (öffnet die Schublade). */
(function () {
  'use strict';
  if (window.KULT && window.KULT.produkt) return;
  window.KULT = window.KULT || {};

  /* ---------- Sprungleiste ---------- */
  function kopfHoehe() {
    /* Impulse setzt beim Scrollen .site-header--stuck auf die feste Kopfzeile */
    var s = document.querySelector('.site-header--stuck');
    return s ? Math.round(s.offsetHeight) : 0; /* Höhe statt Position: beim Einblenden animiert Impulse die Kopfzeile */
  }
  function navStart() {
    var nav = document.querySelector('[data-kp-nav]');
    if (!nav) return;
    var wurzel = nav.closest('.kp');
    var oben = -1;
    function abstand() { var h = kopfHoehe(); if (h !== oben) { oben = h; wurzel.style.setProperty('--kp-top', h + 'px'); } }
    function kopf() {
      var k = document.querySelector('[data-sticky="true"]');
      document.documentElement.style.setProperty('--kp-kopf', (k ? Math.round(k.offsetHeight) : 0) + 'px');
    }
    abstand(); kopf();
    window.addEventListener('resize', function () { abstand(); kopf(); }, { passive: true });
    /* Impulse setzt die Klasse erst in seinem eigenen Scroll-Handler: Klassenwechsel beobachten */
    var kz = document.querySelector('[data-sticky="true"]');
    if (kz && 'MutationObserver' in window) {
      new MutationObserver(function () { requestAnimationFrame(function () { abstand(); markiere(); }); }).observe(kz, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    var nachlauf = 0;
    window.addEventListener('scroll', function () { clearTimeout(nachlauf); nachlauf = setTimeout(function () { abstand(); markiere(); }, 160); }, { passive: true });

    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var ziele = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var leiste = nav.querySelector('.kp-nav__links');
    /* KULT 23.10.2026: mobil Übersicht (data-kp-toc) + einblendbare Leiste mit aufklappbarer Liste */
    var toc = document.querySelector('[data-kp-toc]');
    var btn = nav.querySelector('[data-kp-nav-btn]');
    var akt = nav.querySelector('[data-kp-nav-akt]');
    function zu() { nav.classList.remove('is-offen'); if (btn) btn.setAttribute('aria-expanded', 'false'); }
    if (btn) btn.addEventListener('click', function () { var o = !nav.classList.contains('is-offen'); nav.classList.toggle('is-offen', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    links.forEach(function (a) { a.addEventListener('click', zu); });
    document.addEventListener('click', function (e) { if (nav.classList.contains('is-offen') && !nav.contains(e.target)) zu(); });
    function sichtbar() {
      if (!toc || !toc.offsetHeight) { nav.classList.remove('is-sichtbar'); return; }
      var an = toc.getBoundingClientRect().bottom < Math.max(oben, 0) + 4;
      if (!an) zu();
      nav.classList.toggle('is-sichtbar', an);
    }
    function markiere() {
      var y = Math.max(oben, 0) + nav.offsetHeight + 24;
      var aktiv = -1;
      ziele.forEach(function (z, i) { if (z && z.getBoundingClientRect().top - y <= 0) aktiv = i; });
      links.forEach(function (a, i) {
        var an = i === aktiv;
        if (an !== a.classList.contains('is-aktiv')) {
          a.classList.toggle('is-aktiv', an);
          if (an && leiste && window.innerWidth > 768) leiste.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
        }
      });
      if (akt) akt.textContent = aktiv >= 0 ? (links[aktiv].getAttribute('data-l') || 'Übersicht') : 'Übersicht';
      sichtbar();
    }
    var tick = false;
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(function () { tick = false; abstand(); markiere(); }); } }, { passive: true });
    markiere();
  }

  /* ---------- YouTube-Fassade ---------- */
  function spiele(fig, start) {
    var id = fig.getAttribute('data-kp-yt');
    var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1' + (start ? '&start=' + start : '');
    var ifr = fig.querySelector('iframe');
    if (!ifr) {
      ifr = document.createElement('iframe');
      ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      ifr.setAttribute('allowfullscreen', '');
      ifr.setAttribute('title', (fig.querySelector('.kp-yt__btn') || {}).getAttribute ? fig.querySelector('.kp-yt__btn').getAttribute('aria-label') : 'Video');
      var btn = fig.querySelector('.kp-yt__btn');
      if (btn) btn.remove();
      fig.appendChild(ifr);
    }
    ifr.src = src;
  }

  /* ---------- Vorher / Nachher ---------- */
  function vergleichStart(el) {
    var range = el.querySelector('.kp-cmp__range');
    var aktiv = false;
    function setze(p) { p = Math.max(0, Math.min(100, p)); el.style.setProperty('--pos', p + '%'); if (range) range.value = Math.round(p); }
    function ausX(x) { var r = el.getBoundingClientRect(); setze((x - r.left) / r.width * 100); }
    el.addEventListener('pointerdown', function (e) { aktiv = true; ausX(e.clientX); if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (f) {} } });
    el.addEventListener('pointermove', function (e) { if (aktiv) ausX(e.clientX); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) { el.addEventListener(t, function () { aktiv = false; }); });
    if (range) range.addEventListener('input', function () { setze(parseFloat(range.value)); });
    /* kleiner Hinweis-Schwenk beim ersten Sichtkontakt */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          var t0 = null;
          function schritt(t) {
            if (aktiv) return;
            if (!t0) t0 = t;
            var k = (t - t0) / 1400;
            if (k >= 1) { setze(50); return; }
            setze(50 + Math.sin(k * Math.PI * 2) * 16);
            requestAnimationFrame(schritt);
          }
          requestAnimationFrame(schritt);
        });
      }, { threshold: 0.6 });
      io.observe(el);
    }
  }

  /* ---------- Bildansicht ---------- */
  var lb, lbBilder = [], lbI = 0;
  function lbZeige(i) {
    lbI = (i + lbBilder.length) % lbBilder.length;
    var img = lbBilder[lbI];
    var ziel = lb.querySelector('[data-kp-lb-img]');
    ziel.src = img.getAttribute('data-kp-full') || img.currentSrc || img.src;
    ziel.alt = img.alt || '';
    lb.querySelector('[data-kp-lb-cap]').textContent = img.alt || '';
    var mehr = lbBilder.length > 1;
    lb.querySelector('[data-kp-lb-prev]').hidden = !mehr;
    lb.querySelector('[data-kp-lb-next]').hidden = !mehr;
  }
  function lbOeffne(img) {
    lb = lb || document.querySelector('[data-kp-lb]');
    if (!lb || typeof lb.showModal !== 'function') return;
    var gruppe = img.closest('[data-kp-zoomgroup]');
    var name = gruppe ? gruppe.getAttribute('data-kp-zoomgroup') : '';
    lbBilder = Array.prototype.slice.call(document.querySelectorAll('[data-kp-zoomgroup="' + name + '"] img[data-kp-full]'));
    if (!lbBilder.length) lbBilder = [img];
    lbZeige(Math.max(0, lbBilder.indexOf(img)));
    lb.showModal();
  }

  /* ---------- Warenkorb ---------- */
  function inDenWarenkorb(btn) {
    var id = parseInt(btn.getAttribute('data-kp-add'), 10);
    if (!id) return;
    var text = btn.textContent;
    btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        var w = window.KULT && window.KULT.warenkorb;
        return w && w.abgleich ? w.abgleich('hinzugefuegt', true) : null;
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        btn.textContent = 'Hinzugefügt';
        setTimeout(function () { btn.disabled = false; btn.textContent = text; }, 1800);
      })
      .catch(function () { btn.disabled = false; btn.textContent = text; window.location.href = '/cart'; });
  }

  /* ---------- Klicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var yt = t.closest('.kp-yt__btn');
    if (yt) { e.preventDefault(); var fy = yt.closest('[data-kp-yt]'); spiele(fy, parseInt(fy.getAttribute('data-s'), 10) || 0); return; } /* KULT 22.10.2026: Startzeit über data-s (Praxisfälle) */

    var jump = t.closest('[data-kp-jump]');
    if (jump) {
      e.preventDefault();
      var id = jump.getAttribute('data-kp-jump');
      var fig = document.querySelector('[data-kp-yt="' + id + '"]');
      if (!fig) return;
      var karte = fig.closest('.kp-vid');
      if (karte && karte.hidden) { var alle = document.querySelector('[data-kp-filter=""]'); if (alle) alle.click(); }
      if (karte && karte.classList.contains('kp-vid--mehr')) { var mk2 = document.querySelector('[data-kp-mehr]'); if (mk2) mk2.click(); }
      spiele(fig, parseInt(jump.getAttribute('data-s'), 10) || 0);
      if (!jump.closest('.kp-vid')) fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var f = t.closest('[data-kp-filter]');
    if (f) {
      var k = f.getAttribute('data-kp-filter');
      Array.prototype.forEach.call(f.parentNode.querySelectorAll('[data-kp-filter]'), function (b) {
        var an = b === f; b.classList.toggle('is-aktiv', an); b.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
      Array.prototype.forEach.call(document.querySelectorAll('.kp-vid[data-kp-kat]'), function (v) {
        v.hidden = !!k && (' ' + v.getAttribute('data-kp-kat') + ' ').indexOf(' ' + k + ' ') === -1;
      });
      var raster = document.querySelector('.kp-vids');
      if (raster && k) { raster.classList.add('is-alle'); var mk = document.querySelector('[data-kp-mehr]'); if (mk) mk.parentNode.hidden = true; }
      return;
    }

    var mehr = t.closest('[data-kp-mehr]');
    if (mehr) {
      var r = document.querySelector('.kp-vids');
      if (r) r.classList.add('is-alle');
      mehr.parentNode.hidden = true;
      return;
    }

    var z = t.closest('.kp-zoom');
    if (z) { var img = z.querySelector('img[data-kp-full]'); if (img) { e.preventDefault(); lbOeffne(img); } return; }

    if (t.closest('[data-kp-lb-close]')) { lb.close(); return; }
    if (t.closest('[data-kp-lb-prev]')) { lbZeige(lbI - 1); return; }
    if (t.closest('[data-kp-lb-next]')) { lbZeige(lbI + 1); return; }
    if (lb && t === lb) { lb.close(); return; }

    var add = t.closest('[data-kp-add]');
    if (add) { e.preventDefault(); inDenWarenkorb(add); }
  });
  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.open) return;
    if (e.key === 'ArrowLeft') lbZeige(lbI - 1);
    if (e.key === 'ArrowRight') lbZeige(lbI + 1);
  });

  function start() {
    navStart();
    Array.prototype.forEach.call(document.querySelectorAll('[data-kp-cmp]'), vergleichStart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.KULT.produkt = { spiele: spiele };
})();
